import type { ThemeUIStyleObject } from 'theme-ui';

export const hr: Record<string, ThemeUIStyleObject> = {
	hr: {
		color: 'neutral-grey100',
	},
};
